export const CONFIRMATION_TYPE = Object.freeze({
  WHATSAPP: 'whatsapp',
});

export const USER_TYPE = Object.freeze({
  OWNER: 'owner',
  LISTING_REPRESENTATIVE: 'listingRepresentative',
});
